<template>
  <div class="copywriting-page">
    <el-collapse v-model="activeName" class="el-panel_wrapper">
      <el-collapse-item title="Banner" name="Banner">
        <el-button
          size="mini"
          type="primary"
          @click="add('banners', banners.list.length)"
          >添加 banner</el-button
        >
        <draggable
          class="card-wrapper"
          v-model="banners.list"
          @end="onEnd('banners')"
        >
          <div
            v-for="(item, index) in banners.list"
            :key="String(index)"
            class="card-item"
          >
            <div
              class="card-item_header--image"

              :style="{ 'background-image': `url(${item.image})` }"
            ></div>
            <div class="card-item_modal">
              <el-button
                type="primary"
                icon="el-icon-view"
                circle
                @click="view(banners.list, index)"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-edit"
                @click="edit('banners', item, banners.list, index)"
                circle
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="del('banners', index)"
              ></el-button>
            </div>
          </div>
        </draggable>
      </el-collapse-item>
      <el-collapse-item title="教学团队" name="教学团队">
        <div class="d-flex flex-start" style="margin-bottom: 1rem">
          <span style="margin-right: 1rem">标题</span>
          <el-input
            class="flex-1"
            type="textarea"
            :rows="1"
            v-model.trim="teams.remark"
            placeholder="请输入团队标题"
          ></el-input>
          <el-button
            style="margin-left: 1rem"
            type="primary"
            @click="save(teams)"
            >保存</el-button
          >
        </div>

        <el-button
          size="mini"
          type="primary"
          @click="add('teams', teams.list.length)"
          >添加成员</el-button
        >
        <draggable
          class="card-wrapper"
          v-model="teams.list"
          @end="onEnd('teams')"
        >
          <div
            v-for="(item, index) in teams.list"
            :key="String(index)"
            class="card-item"
          >
            <div class="card-item_header">
              <div
                class="card-item_header--image"
                :style="{ 'background-image': `url(${item.image})` }"
              ></div>
            </div>
            <div class="card-item_content">
              <div class="card-item_content-name">{{ item.name }}</div>
              <div class="card-item_content-title">{{ item.title }}</div>
              <div class="card-item_content-desc">{{ item.desc }}</div>
            </div>
            <div class="card-item_modal">
              <el-button
                type="primary"
                icon="el-icon-view"
                circle
                @click="view(teams.list, index)"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-edit"
                @click="edit('teams', item, teams.list, index)"
                circle
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="del('teams', index)"
              ></el-button>
            </div>
          </div>
        </draggable>
      </el-collapse-item>
      <el-collapse-item title="课程支持" name="课程支持">
        <div style="width: 80%">
          <el-form label-width="100px">
            <el-form-item label="标题">
              <el-input
                type="textarea"
                v-model="c_supports.list[0].desc"
              ></el-input>
            </el-form-item>
            <el-form-item label="课程支持图片">
              <el-upload
                accept="image/*"
                v-loading="elCourseSupportUploadLoading"
                ref="elCourseSupportUpload"
                :before-upload="
                  () => beforeUpload('elCourseSupportUploadLoading')
                "
                :show-file-list="false"
                :action="action"
                :headers="headers"
                :on-error="
                  (res) =>
                    onError(
                      'elCourseSupportUpload',
                      res,
                      'elCourseSupportUploadLoading'
                    )
                "
                :on-success="
                  (res) =>
                    onSuccess(
                      res,
                      'image',
                      'c_supports.list',
                      'elCourseSupportUploadLoading'
                    )
                "
              >
                <div v-if="c_supports.list[0].image" class="el-form-item_image">
                  <img
                    style="width: 100%"
                    :src="c_supports.list[0].image"
                    alt=""
                  />
                  <div class="img_modal">
                    <span class="button">点击更换</span>
                  </div>
                </div>
                <el-button v-else size="small" type="primary"
                  >点击上传</el-button
                >
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="save(c_supports)"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item title="宣传视频" name="宣传视频">
        <div style="width: 80%">
          <el-form label-width="100px">
            <el-form-item label="标题">
              <el-input
                type="textarea"
                v-model="d_supports.list[0].desc"
              ></el-input>
            </el-form-item>
            <el-form-item label="视频介绍">
              <el-upload
                v-loading="elDeviceSupportUploadLoading"
                accept=".mp4"
                ref="elDeviceSupportUpload"
                :before-upload="
                  () => beforeUpload('elDeviceSupportUploadLoading')
                "
                :show-file-list="false"
                :action="action"
                :headers="headers"
                :on-error="
                  (res) =>
                    onError(
                      'elDeviceSupportUpload',
                      res,
                      'elDeviceSupportUploadLoading'
                    )
                "
                :on-success="
                  (res) =>
                    onSuccess(
                      res,
                      'video',
                      'd_supports.list',
                      'elDeviceSupportUploadLoading'
                    )
                "
              >
                <div v-if="d_supports.list[0].video" class="el-form-item_image">
                  <video
                    style="width: 100%"
                    :src="d_supports.list[0].video"
                    controlslist="nodownload"
                    :disablePictureInPicture="true"
                  ></video>
                  <div class="img_modal">
                    <span class="button">点击更换</span>
                  </div>
                </div>
                <el-button v-else size="small" type="primary"
                  >点击上传</el-button
                >
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="save(d_supports)"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item title="教学方式" name="教学方式">
        <div class="d-flex flex-start" style="margin-bottom: 1rem">
          <span style="margin-right: 1rem">标题</span>
          <el-input
            class="flex-1"
            type="textarea"
            :rows="1"
            v-model.trim="t_mode.remark"
            placeholder="请输入标题"
          ></el-input>
          <el-button
            style="margin-left: 1rem"
            type="primary"
            @click="save(t_mode)"
            >保存</el-button
          >
        </div>
        <el-button
          size="mini"
          type="primary"
          @click="add('t_mode', t_mode.list.length)"
          >添加教学方式</el-button
        >
        <draggable
          class="card-wrapper"
          v-model="t_mode.list"
          @end="onEnd('t_mode')"
        >
          <div
            v-for="(item, index) in t_mode.list"
            :key="String(index)"
            class="card-item"
          >
            <div class="card-item_header">
              <div
                class="card-item_header--image"
                :style="{ 'background-image': `url(${item.image})` }"
              ></div>
            </div>
            <div class="card-item_content">
              <div class="card-item_content-title">{{ item.title }}</div>
              <div class="card-item_content-desc">{{ item.desc }}</div>
            </div>
            <div class="card-item_modal">
              <el-button
                type="primary"
                icon="el-icon-view"
                circle
                @click="view(t_mode.list, index)"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-edit"
                @click="edit('t_mode', item, t_mode.list, index)"
                circle
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="del('t_mode', index)"
              ></el-button>
            </div>
          </div>
        </draggable>
      </el-collapse-item>
      <el-collapse-item title="培训体系" name="培训体系">
        <el-button
          size="mini"
          type="primary"
          @click="add('t_system', t_system.list.length)"
          >添加培训体系</el-button
        >
        <draggable
          class="card-wrapper"
          v-model="t_system.list"
          @end="onEnd('t_system')"
        >
          <div
            v-for="(item, index) in t_system.list"
            :key="String(index)"
            class="card-item"
          >
            <div class="card-item_header">
              <div
                class="card-item_header--image"
                :style="{ 'background-image': `url(${item.image})` }"
              ></div>
            </div>
            <div class="card-item_content">
              <div class="card-item_content-title">{{ item.title }}</div>
              <div class="card-item_content-desc">{{ item.desc }}</div>
            </div>
            <div class="card-item_modal">
              <el-button
                type="primary"
                icon="el-icon-view"
                circle
                @click="view(t_system.list, index)"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-edit"
                @click="edit('t_system', item, t_system.list, index)"
                circle
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="del('t_system', index)"
              ></el-button>
            </div>
          </div>
        </draggable>
      </el-collapse-item>
      <el-collapse-item title="合作流程" name="合作流程">
        <div style="width: 80%">
          <el-form label-width="100px">
            <el-form-item label="合作流程描述">
              <el-input
                type="textarea"
                v-model="cooperation_process.list[0].desc"
              ></el-input>
            </el-form-item>
            <el-form-item label="合作流程图片">
              <el-upload
                accept="image/*"
                v-loading="elCooperationProcessUploadLoading"
                ref="elCooperationProcessUpload"
                :before-upload="
                  () => beforeUpload('elCooperationProcessUploadLoading')
                "
                :show-file-list="false"
                :action="action"
                :headers="headers"
                :on-error="
                  (res) =>
                    onError(
                      'elCooperationProcessUpload',
                      res,
                      'elCooperationProcessUploadLoading'
                    )
                "
                :on-success="
                  (res) =>
                    onSuccess(
                      res,
                      'image',
                      'cooperation_process.list',
                      'elCooperationProcessUploadLoading'
                    )
                "
              >
                <div
                  v-if="cooperation_process.list[0].image"
                  class="el-form-item_image"
                >
                  <img
                    style="width: 100%"
                    :src="cooperation_process.list[0].image"
                    alt=""
                  />
                  <div class="img_modal">
                    <span class="button">点击更换</span>
                  </div>
                </div>
                <el-button v-else size="small" type="primary"
                  >点击上传</el-button
                >
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="save(cooperation_process)"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item title="合作案例" name="合作案例">
        <el-button
          size="mini"
          type="primary"
          @click="add('cooperation_case', cooperation_case.list.length)"
          >添加案例</el-button
        >
        <draggable
          class="card-wrapper"
          v-model="cooperation_case.list"
          @end="onEnd('cooperation_case')"
        >
          <div
            v-for="(item, index) in cooperation_case.list"
            :key="String(index)"
            class="card-item"
          >
            <div class="card-item_header">
              <div
                class="card-item_header--image"
                :style="{ 'background-image': `url(${item.image})` }"
              ></div>
            </div>
            <div class="card-item_content">
              <div class="card-item_content-title">{{ item.title }}</div>
            </div>
            <div class="card-item_modal">
              <el-button
                type="primary"
                icon="el-icon-view"
                circle
                @click="view(cooperation_case.list, index)"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-edit"
                @click="
                  edit('cooperation_case', item, cooperation_case.list, index)
                "
                circle
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="del('cooperation_case', index)"
              ></el-button>
            </div>
          </div>
        </draggable>
      </el-collapse-item>
      <el-collapse-item title="底部信息" name="底部信息">
        <div style="width: 80%">
          <el-form label-width="100px">
            <el-form-item label="版权©️">
              <el-input v-model="footer.list[0].copyright"></el-input>
            </el-form-item>
            <el-form-item label="网站备案号">
              <el-input v-model="footer.list[0].icp"></el-input>
            </el-form-item>
            <el-form-item label="纠纷和解员">
              <el-input v-model="footer.list[0].ipman"></el-input>
            </el-form-item>
            <el-form-item label="和解员电话">
              <el-input v-model="footer.list[0].ipman_phone"></el-input>
            </el-form-item>
            <el-form-item label="公司注册局">
              <el-input v-model="footer.list[0].company_place"></el-input>
            </el-form-item>
            <el-form-item label="投诉电话">
              <el-input v-model="footer.list[0].fbi_phone"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="save(footer)">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item title="右侧小方块" name="右侧小方块">
        <el-button
          size="mini"
          type="primary"
          @click="add('sider', sider.list.length)"
          >添加小方块</el-button
        >
        <draggable
          class="card-wrapper"
          v-model="sider.list"
          @end="onEnd('sider')"
        >
          <div
            v-for="(item, index) in sider.list"
            :key="String(index)"
            class="card-item"
          >
            <div class="card-item_header">
              <div
                class="card-item_header--image"
                :style="{ 'background-image': `url(${item.image})` }"
              ></div>
            </div>
            <div class="card-item_content">
              <div class="card-item_content-desc">{{ item.desc }}</div>
            </div>
            <div class="card-item_modal">
              <el-button
                type="primary"
                icon="el-icon-view"
                circle
                @click="view(sider.list, index)"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-edit"
                @click="edit('sider', item, sider.list, index)"
                circle
              ></el-button>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                @click="del('sider', index)"
              ></el-button>
            </div>
          </div>
        </draggable>
      </el-collapse-item>
    </el-collapse>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      destroy-on-close
    >
      <el-form label-width="80px" :model="dataForm">
        <el-form-item
          v-for="(item, idx) in formItems"
          :key="String(idx)"
          :label="item.label"
        >
          <template v-if="item.type === 'image'">
            <tx-upload v-model="dataForm[item.key]"></tx-upload>
            <!-- <el-upload
              ref="elUpload"
              accept="image/*"
              :show-file-list="false"
              :action="action"
              v-loading="elDialogUploadLoading"
              :before-upload="() => beforeUpload('elDialogUploadLoading')"
              :headers="headers"
              :on-error="
                (res) => onError('elUpload', res, 'elDialogUploadLoading')
              "
              :on-success="
                (res) =>
                  onSuccess(res, item.key, 'dataForm', 'elDialogUploadLoading')
              "
            >
              <div v-if="dataForm[item.key]" class="el-form-item_image">
                <img style="width: 100%" :src="dataForm[item.key]" alt="" />
                <div class="img_modal">
                  <span class="button">点击更换</span>
                </div>
              </div>
              <el-button v-else size="small" type="primary">点击上传</el-button>
            </el-upload> -->
          </template>
          <template v-else>
            <el-input v-model="dataForm[item.key]"></el-input>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit" :loading="loading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="viewVisible" class="el-fullscreen-dialog">
      <el-carousel
        :loop="false"
        ref="elcarousel"
        height="600px"
        style="margin: 20px"
        :autoplay="false"
        v-if="viewVisible"
        :initial-index="initialIndex"
      >
        <el-carousel-item
          v-for="(item, idx) in images"
          class="el-carousel-item_bg"
          :key="String(idx)"
          :style="{ 'background-image': `url(${item.image})` }"
        ></el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import cloneDeep from "clone-deep";
import draggable from "vuedraggable";
import { makeSgin } from "@/utils";
import { UpdataDraggable } from "@/api/site";
const formItems = {
  banners: [
    {
      label: "标题",
      key: "banner",
    },
    {
      label: "地址",
      key: "desc",
    },
    {
      label: "图片",
      type: "image",
      key: "image",
    },
  ],
  teams: [
    {
      label: "姓名",
      key: "name",
    },
    {
      label: "头衔",
      key: "title",
    },
    {
      label: "描述",
      key: "desc",
    },
    {
      label: "图片",
      type: "image",
      key: "image",
    },
  ],
  t_mode: [
    {
      label: "标题",
      key: "title",
    },
    {
      label: "描述",
      key: "desc",
    },
    {
      label: "图片",
      type: "image",
      key: "image",
    },
  ],
  t_system: [
    {
      label: "标题",
      key: "title",
    },
    {
      label: "描述",
      key: "desc",
    },
    {
      label: "图片",
      type: "image",
      key: "image",
    },
  ],
  cooperation_case: [
    {
      label: "标题",
      key: "title",
    },
    {
      label: "图片",
      type: "image",
      key: "image",
    },
  ],
  sider: [
    {
      label: "描述",
      key: "desc",
    },
    {
      label: "图片",
      type: "image",
      key: "image",
    },
  ],
};

export default {
  components: { draggable },
  data() {
    return {
      activeName: "Banner",
      dialogTitle: "新增",
      loading: false,
      action: process.env.VUE_APP_API_URL + "sys/oss/upload",
      headers: {
        token: this.$cookie.get("token"),
      },
      elDialogUploadLoading: false,
      elCourseSupportUploadLoading: false,
      elDeviceSupportUploadLoading: false,
      elCooperationProcessUploadLoading: "",
      copywriting_type: "",
      target: null,
      targetIdx: 0,
      dataForm: {},
      activeNames: ["1", "2", "3", "4", "5", "6", "7", "8"],
      images: [],
      initialIndex: 0,
      dialogVisible: false,
      viewVisible: false,
      banners: {
        list: [],
      },
      teams: {
        list: [],
      },
      c_supports: {
        list: [
          {
            desc: "",
            image: "",
          },
        ],
      },
      d_supports: {
        list: [
          {
            desc: "",
            video: "",
          },
        ],
      },
      t_mode: {
        list: [],
      },
      t_system: {
        list: [],
      },
      cooperation_process: {
        list: [
          {
            desc: "",
            image: "",
          },
        ],
      },
      cooperation_case: {
        list: [],
      },
      footer: {
        list: [{}],
      },
      sider: {
        list: [],
      },
      formItems: [],
    };
  },
  created() {
    this.getCopywritings();
  },
  methods: {
    onSuccess(res, key, form, loading) {
      if (res.code == 0) {
        if (form.indexOf(".") !== -1) {
          const [parent, children] = form.split(".");
          this[parent][children][0][key] = res.url;
        } else {
          this.$set(this[form], key, res.url);
        }
        this.$forceUpdate();
      }
      this[loading] = false;
    },
    onError(ref, res, loading) {
      this.$refs[ref].clearFiles();
      this.$message.error(res.msg);
      this[loading] = false;
    },
    beforeUpload(loading) {
      this[loading] = true;
    },
    view(target, index) {
      this.images = target;
      this.initialIndex = index;
      this.viewVisible = true;
    },
    add(type, idx) {
      this.dialogTitle = "新增";
      const target = this[type];
      let cur = target.list[idx];
      if (!cur) {
        cur = { sort: idx };
        formItems[type].forEach((i) => {
          cur[i.key] = "";
        });
      }
      console.log("cur", cur);
      this.edit(type, cur, target.list, idx);
    },
    edit(type, cur, data, idx) {
      this.dialogTitle = "更新";
      this.target = this[type];
      this.targetIdx = idx;
      this.copywriting_type = type;
      this.formItems = formItems[type];
      this.dataForm = cloneDeep(cur);
      this.dialogVisible = true;
    },
    submit() {
      const params = cloneDeep(this.target);
      params.list[this.targetIdx] = this.dataForm;
      params.paramValue = JSON.stringify(params.list);
      delete params.list;
      this.update(params);
    },
    save(data) {
      const params = cloneDeep(data);
      params.paramValue = JSON.stringify(params.list);
      delete params.list;
      this.update(params);
    },
    update(params) {
      this.loading = false;
      this.$http({
        url: this.$http.adornUrl("sys/config/update"),
        method: "put",
        data: params,
      })
        .then(({ data }) => {
          if (data.code == 0) {
            this.$message.success("更新成功！");
            this.dialogVisible = false;
            this.getCopywritingsByKey(params.id);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getCopywritingsByKey(id) {
      this.$http({
        url: this.$http.adornUrl(`sys/config/info/${id}`),
        method: "get",
      }).then(({ data }) => {
        console.log(data, "getCopywritingsByKey");
        this[this.copywriting_type] = {
          ...data.config,
          list: JSON.parse(data.config.paramValue),
        };
      });
    },
    getCopywritings() {
      this.$http({
        url: this.$http.adornUrl("open/api/homePage?sign=" + makeSgin()),
        method: "get",
      }).then(({ data }) => {
        data.data.forEach((i) => {
          switch (i.paramKey) {
            case "HOME_PAGE_1":
              this.banners = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
            case "HOME_PAGE_2":
              this.teams = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
            case "HOME_PAGE_3":
              this.c_supports = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
            case "HOME_PAGE_4":
              this.d_supports = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
            case "HOME_PAGE_5":
              this.t_mode = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
            case "HOME_PAGE_6":
              this.t_system = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
            case "HOME_PAGE_7":
              this.cooperation_process = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
            case "HOME_PAGE_8":
              this.cooperation_case = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
            case "HOME_PAGE_9":
              this.footer = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
            case "HOME_PAGE_10":
              this.sider = {
                ...i,
                list: JSON.parse(i.paramValue),
              };
              break;
          }
        });
      });
    },
    del(type, idx) {
      this.copywriting_type = type;
      const params = cloneDeep(this[type]);
      params.list.splice(idx, 1);
      params.paramValue = JSON.stringify(params.list);
      delete params.list;
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.update(params);
      });
    },
    async onEnd(type) {
      const data = this[type];
      data.paramValue = JSON.stringify(data.list);
      delete data.list;
      try {
        const res = await UpdataDraggable(data);
        console.log(res);
        if (res.data.code === 0) {
          this.$message.success("修改成功");
        } else {
          this.$message.error("修改失败");
        }
      } catch (error) {
        this.$message.error("修改失败");
      }
    },
  },
};
</script>

<style lang="scss">
.copywriting-page {
  .el-collapse {
    border: none;
  }
  .el-collapse-item {
    border: none;
    & + .el-collapse-item {
      margin-top: 1rem;
    }
  }
  .el-collapse-item__content {
    padding: 1rem;
  }
  .el-collapse-item__wrap {
    border: none;
  }
  .el-collapse-item__arrow {
    line-height: 36px;
  }
  .el-collapse-item__header {
    background-color: #fafafa;
    height: 36px;
    padding-left: 1rem;
    line-height: 36px;
    border-radius: 4px;
    overflow: hidden;
    border: none;
  }
  .card-wrapper {
    display: flex;
    align-items: center;
    margin-top: 1rem;
    flex-wrap: wrap;
    .card-item {
      width: 300px;
      margin-right: 1rem;
      margin-bottom: 1rem;
      border-radius: 5px;
      position: relative;
      transition: all 0.3s;
      overflow: hidden;
      box-shadow: 0 0 1rem 0 rgba($color: #000000, $alpha: 0.2);
      .card-item_modal {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        color: #ffffff;
        font-size: 1rem;
        height: 100%;
        overflow: hidden;
        opacity: 0;
        visibility: hidden;
        will-change: height;
        transition: all 0.3s;
        background-color: rgba($color: #000000, $alpha: 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &:hover {
        .card-item_modal {
          visibility: visible;
          opacity: 1;
        }
      }
    }
    .card-item_content {
      padding: 1rem;
    }
    .card-item_header--image {
      width: 300px;
      height: 200px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
    .card-item_content-name {
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }
    .card-item_content-title {
      margin-bottom: 0.5rem;
    }
    .card-item_content-desc {
      height: 69px;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
  .el-carousel-item_bg {
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .el-form-item_image {
    position: relative;
    min-height: 100px;
    min-width: 100px;
    .img_modal {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      color: #ffffff;
      font-size: 1rem;
      height: 100%;
      overflow: hidden;
      opacity: 0;
      visibility: hidden;
      will-change: height;
      transition: all 0.3s;
      background-color: rgba($color: #000000, $alpha: 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      .button {
        padding: 2px 1rem;
        border-radius: 4px;
        cursor: pointer;
        background-color: rgba($color: #000000, $alpha: 0.6);
      }
    }
    &:hover {
      .img_modal {
        visibility: visible;
        opacity: 1;
      }
    }
  }
}
</style>
